module.exports = __webpack_public_path__ + "img/mobile-legends.6c29a5e.jpg";